const buildBorderedTooltipSlotProps = (backgroundColor: string) => ({
  tooltip: { sx: { backgroundColor, border: '1px solid var(--border-medium)' } },
  arrow: { sx: { color: backgroundColor, '&::before': { border: '1px solid var(--border-medium)', boxSizing: 'border-box' } } }
})

export const DEVICE_TOOLTIP_SLOT_PROPS = buildBorderedTooltipSlotProps('var(--bg-surface)')

const CATEGORY_TOOLTIP_SLOT_PROPS_BASE = buildBorderedTooltipSlotProps('var(--bg-page)')

export const CATEGORY_TOOLTIP_SLOT_PROPS = {
  ...CATEGORY_TOOLTIP_SLOT_PROPS_BASE,
  tooltip: { sx: { ...CATEGORY_TOOLTIP_SLOT_PROPS_BASE.tooltip.sx, maxWidth: 'var(--size-408)' } }
}
